import React, { Component } from 'react';
import { func, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PastWeatherActions from '../actions/pastWeatherActions';
import PastWeatherControls from '../components/PastWeather/PastWeatherControls';
import { AccumulatedPrecipitation } from '../components/PastWeather/AccumulatedPrecipitation';
import { DailyPrecipitation } from '../components/PastWeather/DailyPrecipitation';
import { HighLowTemperatures } from '../components/PastWeather/HighLowTemperatures';
import { PastWeatherType } from '../types';
import { Error } from '../components/PastWeather/Error';
import styles from './css/PastWeatherContainer.css';
import * as AnalyticsActions from '../actions/analyticsActions';

export class PastWeatherContainer extends Component {
  componentDidMount() {
    const { getPastWeather } = this.props;

    getPastWeather();
  }

  updateValue = (e) => {
    const {
      updatePastWeatherInput,
      getHistoricalWeather,
      clearHistoricalData,
      trackEvent,
    } = this.props;
    updatePastWeatherInput(e.target.name, e.target.value);
    const numbers = e.target.value.match(/\d+/);
    const numYears = numbers && numbers[0];

    if (e.target.name === 'yearAverage' && numYears) {
      getHistoricalWeather();
    } else {
      clearHistoricalData();
    }

    trackEvent('past_weather', 'updated', {
      updated_option: 'compare_button',
      updated_value: numYears ? `${numYears}_years_average` : 'none',
    });
  };

  render() {
    const {
      pastWeather,
      clearPastWeatherFailure,
      getHistoricalWeather,
      getPastWeather,
      updatePastWeatherInput,
      togglePrecipitationHelp,
      toggleTemperatureHelp,
    } = this.props;

    const {
      accumulatedPrecipitation,
      endDate,
      formattedDates,
      precipitation,
      startDate,
      temperature,
      yearAverage,
      pastWeatherError,
      harvestYear,
    } = pastWeather;

    if (pastWeatherError) {
      return (
        <Error
          clearPastWeatherFailure={clearPastWeatherFailure}
          message={pastWeatherError}
          testId="past-weather-error"
        />
      );
    }

    return (
      <div
        className={styles.pastWeatherContainer}
        data-test-id="past-weather-container"
      >
        <PastWeatherControls
          endDate={endDate}
          getHistoricalWeather={getHistoricalWeather}
          getPastWeather={getPastWeather}
          harvestYear={harvestYear}
          startDate={startDate}
          updatePastWeatherInput={updatePastWeatherInput}
          updateValue={this.updateValue}
          yearAverage={yearAverage}
        />

        <AccumulatedPrecipitation
          accumulatedPrecipitation={accumulatedPrecipitation}
          endDate={endDate}
          formattedDates={formattedDates}
          precipitationHelp={precipitation.help}
          startDate={startDate}
          toggleHelp={togglePrecipitationHelp}
          yearAverage={yearAverage}
        />

        {/* Had precipitation.historical, but wasn't being used */}
        <DailyPrecipitation
          endDate={endDate}
          formattedDates={formattedDates}
          precipitation={precipitation}
          startDate={startDate}
        />

        {/*
          TODO: historicalData.temp values are not used currently. Should it be?
          If not, update pastWeatherReducer
          historicalData={temperature.historical.max}
        */}
        <HighLowTemperatures
          endDate={endDate}
          formattedDates={formattedDates}
          startDate={startDate}
          temperature={temperature}
          toggleHelp={toggleTemperatureHelp}
        />
      </div>
    );
  }
}

PastWeatherContainer.propTypes = {
  clearHistoricalData: func.isRequired,
  clearPastWeatherFailure: func.isRequired,
  getHistoricalWeather: func.isRequired,
  getPastWeather: func.isRequired,
  pastWeather: PastWeatherType,
  pastWeatherError: string,
  togglePrecipitationHelp: func.isRequired,
  toggleTemperatureHelp: func.isRequired,
  trackEvent: func.isRequired,
  updatePastWeatherInput: func.isRequired,
};

function mapStateToProps(state) {
  return {
    pastWeather: state.pastWeather,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...PastWeatherActions,
      ...AnalyticsActions,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PastWeatherContainer);
